import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import themeSchema from '../../../lib/composer/schemas/theme';
import { ctaSchema, ctasSchema } from '../../../lib/composer/schemas/cta';
import textSchema from '../../../lib/composer/schemas/text';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import headingSchema from '../../../lib/composer/schemas/heading';
import mediaSchema from '../../../lib/composer/schemas/media';
import CTAs from '../block-ui/CTAs';
import BlockWrapper from '../BlockWrapper';
import Heading from '../block-ui/Heading';
import Subheading from '../block-ui/Subheading';
import Media from '../block-ui/Media';
import RichText from '../block-ui/RichText';
import { MediaAndTextBlockProps } from '../../../types/composer';

type Props = MediaAndTextBlockProps & { renderBlockWrapper?: boolean };

/**
 * Media and text block.
 */
// FIXME: any
const MediaAndText: any = (props: Props) => {
  const {
    heading,
    subheading,
    cta: ctaProps,
    ctas: ctasProps,
    text,
    theme = '',
    media,
    renderBlockWrapper = true,
    topHeader,
  } = props;

  const colors = useColors();

  const bg = colors[theme] || 'bg-0';

  const ctas = [...(ctaProps?.caption ? [ctaProps] : []), ...(ctasProps || [])];

  const renderWrapper = (children: React.ReactNode) => {
    return renderBlockWrapper ? (
      <BlockWrapper>{children}</BlockWrapper>
    ) : (
      children
    );
  };

  return (
    <Box bg={bg}>
      {renderWrapper(
        <Flex
          flexDirection={[
            'column',
            media.alignment === 'left' ? 'row-reverse' : 'row',
          ]}
          alignItems="center"
          margin="auto"
        >
          <Flex flexDirection="column" sx={{ gap: 3 }} flex={1} mx={3}>
            <Heading text={heading} theme={theme} topHeader={topHeader} />

            {subheading && (
              <Subheading
                text={subheading}
                theme={theme}
                topHeader={topHeader}
              />
            )}
            {text && <RichText theme={theme} html={text} />}
            <CTAs ctas={ctas} theme={theme} />
          </Flex>

          <Box mx={3} flex={1}>
            <Media media={media} />
          </Box>
        </Flex>,
      )}
    </Box>
  );
};

MediaAndText.schema = {
  name: 'media-and-text',
  label: 'Media with Text',
  editableProps: [
    headingSchema,
    subheadingSchema,
    textSchema,
    {
      ...mediaSchema,
      properties: {
        ...mediaSchema.properties,
        alignment: {
          ...mediaSchema.properties.alignment,
          selectOptions: {
            options: [
              {
                value: 'right',
                label: 'Right',
              },
              {
                value: 'left',
                label: 'Left',
              },
            ],
          },
        },
      },
    },
    ctaSchema,
    ctasSchema,
    themeSchema,
  ],
};

export default MediaAndText;
